<template>
  <div>
    <el-row>
      <el-form inline>
        <div style="float: left">
          <el-form-item label="集群">
            <el-input v-model="cluster.name" disabled></el-input>
          </el-form-item>
          <el-form-item label="命名空间">
            <el-select
              defaultValue="default"
              :value="namespace"
              @change="change_namespace"
              placeholder="请选择命名空间"
            >
              <el-option
                v-for="i in namespaces"
                :key="i.metadata.uuid"
                :value="i.metadata.name"
                :label="i.metadata.name"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <el-button-group style="float: right">
        <el-button size="small" type="primary" @click="show_create"
          >创建 Role</el-button
        >
        <el-button size="small" type="primary" @click="show_create_rolebinding"
          >创建 RoleBinding</el-button
        >
      </el-button-group>
    </el-row>

    <!-- 创建 role -->
    <el-dialog :visible.sync="create" title="创建 Role" width="30%">
      <el-form ref="role" :model="role" label-width="80px">
        <el-form-item label="特殊资源">
          <el-radio-group v-model="role.name">
            <el-radio label="admin"></el-radio>
            <el-radio label="read-only"></el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <template slot="footer">
        <el-button size="small" @click="create = false">取消</el-button>
        <el-button size="small" type="primary" @click="create_role"
          >创建</el-button
        >
      </template>
    </el-dialog>

    <!-- 创建 rolebinding -->
    <el-dialog
      :visible.sync="create_rolebinding"
      title="创建 RoleBinding"
      width="30%"
    >
      <el-form ref="rolebinding" :model="rolebinding" label-width="80px">
        <el-form-item label="特殊资源">
          <el-radio-group v-model="rolebinding.name">
            <el-radio label="admin"></el-radio>
            <el-radio label="read-only"></el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <template slot="footer">
        <el-button size="small" @click="create = false">取消</el-button>
        <el-button size="small" type="primary" @click="create_rolebinding_func"
          >创建</el-button
        >
      </template>
    </el-dialog>

    <!-- 修改 rolebinding -->
    <el-dialog :visible.sync="edit" title="编辑 RoleBinding" width="30%">
      <el-form
        ref="edit_rolebinding"
        :model="edit_rolebinding"
        label-width="80px"
      >
        <el-form-item label="选择用户">
          <el-select
            multiple
            :value="mid_users"
            placeholder="选择角色"
            @change="edit_user"
            style="display: block"
          >
            <el-option
              v-for="i in users"
              :key="i.id"
              :label="i.name"
              :value="i.name"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template slot="footer">
        <el-button size="small" @click="edit = false">取消</el-button>
        <el-button size="small" type="primary" @click="update_rolebinding"
          >修改</el-button
        >
      </template>
    </el-dialog>

    <el-tabs type="border-card">
      <el-tab-pane label="Role 管理">
        <el-table :data="roles" :pagination="false" border>
          <el-table-column label="名称" prop="metadata.name"></el-table-column>
          <el-table-column
            label="创建时间"
            prop="metadata.creationTimestamp"
          ></el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="RoleBinding 管理">
        <el-table :data="rolebindings" :pagination="false" border>
          <el-table-column label="名称" prop="metadata.name"></el-table-column>
          <el-table-column
            label="创建时间"
            prop="metadata.creationTimestamp"
          ></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="record">
              <el-button
                size="mini"
                type="primary"
                @click="get_rolebinding(record.row.metadata.name)"
                >编辑</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  data() {
    return {
      namespaces: [],
      roles: [],
      rolebindings: [],
      cluster: {
        name: "",
      },
      namespace: "",
      create: false,
      create_rolebinding: false,
      role: {
        name: "",
      },
      rolebinding: {
        name: "",
      },
      edit: false,
      edit_rolebinding: {},
      users: [],
      mid_users: [],
    };
  },
  async created() {
    await this.get_cluster();
    this.get_namespaces();
    this.get_users();
  },
  methods: {
    get_cluster() {
      const _this = this;
      let id = _this.$route.params.id;
      return _this.$axios
        .get(_this.config.path + "/k8sclusters/" + id, {
          headers: {
            Authorization: "Bearer " + _this.config.getCookie(),
          },
        })
        .then(function (res) {
          if (res.data.success === false) {
            _this.$message({
              message: "获取集群信息失败: " + res.data.message,
              showClose: true,
              type: "error",
            });
          } else {
            _this.cluster = res.data.data;
            console.log(_this.cluster);
          }
        })
        .catch(function (err) {
          _this.$message({
            message: "获取集群信息失败: " + err.toString(),
            showClose: true,
            type: "error",
          });
        });
    },
    get_namespaces() {
      const _this = this;
      _this.namespaces = [];
      _this.$axios
        .get(_this.config.path + "/namespaces?cluster=" + _this.cluster.name, {
          headers: {
            Authorization: "Bearer " + _this.config.getCookie(),
          },
        })
        .then(function (res) {
          if (res.data.success === false) {
            console.log("get namespaces with error: ", res.data.message);
          } else {
            _this.namespaces = res.data.data;
            console.log("active namespace:", _this.namespaces);
            console.log("all namespace", res.data.data);
          }
        })
        .catch(function (err) {
          console.log("get namepsaces with error: ", err.toString());
        });
    },
    change_namespace(value) {
      this.namespace = value;
      this.get_roles(value);
      this.get_rolebindings(value);
    },
    get_roles(namespace) {
      const _this = this;
      _this.$axios
        .get(
          _this.config.path +
            "/k8sroles?cluster=" +
            _this.cluster.name +
            "&namespace=" +
            namespace,
          {
            headers: {
              Authorization: "Bearer " + _this.config.getCookie(),
            },
          }
        )
        .then(function (res) {
          if (res.data.success === false) {
            console.log("get k8s roles with error: ", res.data.message);
          } else {
            _this.roles = res.data.data;
            console.log(res.data.data);
            console.log("roles: ", _this.roles);
          }
        })
        .catch(function (err) {
          console.log("get k8s roles with error: ", err.toString());
        });
    },
    get_rolebindings(namespace) {
      const _this = this;
      _this.$axios
        .get(
          _this.config.path +
            "/k8srolebindings?cluster=" +
            _this.cluster.name +
            "&namespace=" +
            namespace,
          {
            headers: {
              Authorization: "Bearer " + _this.config.getCookie(),
            },
          }
        )
        .then(function (res) {
          if (res.data.success === false) {
            console.log("get k8s rolebindings with error: ", res.data.message);
          } else {
            _this.rolebindings = res.data.data;
          }
        })
        .catch(function (err) {
          console.log("get k8s rolebindings with error: ", err.toString());
        });
    },
    show_create() {
      this.create = true;
    },
    create_role() {
      if (this.namespace === "" || this.role.name === "") {
        this.$message({
          message: "namespace 或 name 没有选",
          showClose: true,
          type: "error",
        });
        return;
      }
      this.role.cluster = this.cluster.name;
      this.role.namespace = this.namespace;
      console.log(this.role);
      const _this = this;
      _this.$axios
        .post(_this.config.path + "/k8sroles", _this.role, {
          headers: {
            Authorization: "Bearer " + _this.config.getCookie(),
          },
        })
        .then(function (res) {
          if (res.data.success === false) {
            console.log("get namespaces with error: ", res.data.message);
          } else {
            _this.namespaces = res.data.data;
            _this.create = false;
          }
        })
        .catch(function (err) {
          console.log("get namepsaces with error: ", err.toString());
        });
    },
    show_create_rolebinding() {
      this.create_rolebinding = true;
    },
    create_rolebinding_func() {
      if (this.namespace === "" || this.rolebinding.name === "") {
        this.$message({
          message: "namespace 或 name 没有选",
          showClose: true,
          type: "error",
        });
        return;
      }
      this.rolebinding.cluster = this.cluster.name;
      this.rolebinding.namespace = this.namespace;
      console.log(this.rolebinding);
      const _this = this;
      _this.$axios
        .post(_this.config.path + "/k8srolebindings", _this.rolebinding, {
          headers: {
            Authorization: "Bearer " + _this.config.getCookie(),
          },
        })
        .then(function (res) {
          if (res.data.success === false) {
            console.log("get namespaces with error: ", res.data.message);
          } else {
            _this.namespaces = res.data.data;
            _this.create_rolebinding = false;
          }
        })
        .catch(function (err) {
          console.log("get namepsaces with error:∏ ", err.toString());
        });
    },
    get_rolebinding(name) {
      this.mid_users = [];
      const _this = this;
      _this.$axios
        .get(
          _this.config.path +
            "/k8srolebindings/" +
            name +
            "?cluster=" +
            _this.cluster.name +
            "&namespace=" +
            _this.namespace,
          {
            headers: {
              Authorization: "Bearer " + _this.config.getCookie(),
            },
          }
        )
        .then(function (res) {
          if (res.data.success === false) {
            console.log("get k8s rolebinding with error: ", res.data.message);
          } else {
            _this.edit_rolebinding = res.data.data;
            if (res.data.data.subjects) {
              for (let i = 0; i < _this.edit_rolebinding.subjects.length; i++) {
                _this.mid_users.push(_this.edit_rolebinding.subjects[i].name);
              }
            }
            _this.edit = true;
          }
        })
        .catch(function (err) {
          console.log("get k8s rolebinding with error: ", err.toString());
        });
    },
    get_users() {
      var _this = this;
      _this.$axios
        .get(_this.config.path + "/users?currentPage=0&pageSize=15", {
          headers: {
            Authorization: "Bearer " + this.config.getCookie(),
          },
        })
        .then(function (response) {
          if (response.data.success === false) {
            _this.$message({
              showClose: true,
              message: "获取用户数据失败: " + response.data.message,
              type: "error",
            });
          } else {
            _this.users = response.data.data;
          }
        })
        .catch(function (error) {
          _this.$message({
            showClose: true,
            message: "获取用户数据失败: " + error.toString(),
            type: "error",
          });
        });
    },
    edit_user(value) {
      this.mid_users = value;
      console.log("current users is:", this.mid_users);
    },
    update_rolebinding() {
      var _this = this;
      _this.$axios
        .put(
          _this.config.path +
            "/k8srolebindings/" +
            _this.edit_rolebinding.metadata.name +
            "?cluster=" +
            _this.cluster.name +
            "&namespace=" +
            _this.namespace,
          {
            users: _this.mid_users,
          },
          {
            headers: {
              Authorization: "Bearer " + this.config.getCookie(),
            },
          }
        )
        .then(function (response) {
          if (response.data.success === false) {
            _this.$message({
              showClose: true,
              message: "修改rolebinding失败: " + response.data.message,
              type: "error",
            });
          } else {
            _this.$message({
              showClose: true,
              message: "修改rolebinding成功",
              type: "success",
            });
            _this.edit = false;
          }
        })
        .catch(function (error) {
          _this.$message({
            showClose: true,
            message: "修改rolebinding失败: " + error.toString(),
            type: "error",
          });
        });
    },
  },
};
</script>
